export default {"src":"/_next/static/media/voting.7450584c.svg","height":426,"width":827};